import { render, staticRenderFns } from "./DataAnalytic.vue?vue&type=template&id=a64450f2&scoped=true&"
import script from "./DataAnalytic.vue?vue&type=script&lang=js&"
export * from "./DataAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalytic.vue?vue&type=style&index=0&id=a64450f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64450f2",
  null
  
)

export default component.exports